// @flow
import {OVERLAY_TOGGLE} from '../actions/overlay';
import type {Action} from '../actions/overlay';

export type State = {
    +showOverlay: boolean
};

const initialState: State = {
    showOverlay: false
};

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    if (action.type === OVERLAY_TOGGLE) {
        return {
            ...state,
            showOverlay: action.payload.isShowing
        };
    }
    return state;
}
